import React, { useState, useEffect ,useRef} from "react";
import { FaTimes } from "react-icons/fa";
import icons from "../../../icons.config";
const SubmitPopup = ({ onClose }) => {

    useEffect(() => {
          // Disable scrolling when modal opens
          document.body.style.overflow = "hidden";
  
          return () => {
              // Re-enable scrolling when modal closes
              document.body.style.overflow = "auto";
          };
      }, []);
      const popupRef = useRef(null);

  useEffect(() => {
    // Function to handle click outside
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose(); // Close the popup
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

return (
    <div className="fixed inset-0 flex items-center justify-center z-30 overflow-y-scroll backdrop-blur-sm  rounded">
      <div className="bg-tertiary p-11 md:p-6 rounded md:w-[50%] relative top-24 lg:top-7 text-center"  ref={popupRef}>
        
        {/* Close button */}
        <div className="absolute top-4 right-4">
          <FaTimes onClick={onClose} className="text-xl cursor-pointer text-white" />
        </div>
  
        {/* Centered Heading */}
        <h1 className="font-outfit text-2xl lg:text-3xl mb-4 text-white">YOUR QUERY HAS BEEN PLACED</h1>
  
        {/* Centered Image */}  
        <div className="flex justify-center">
          <img src={icons.contactUsPopUp} alt="Contact Us PopUp" className="w-32 md:w-40 h-32 md:h-40" />
        </div>
  
        {/* Centered Paragraph */}
        <p className="mt-4 text-md lg:text-lg text-white">
        Your query has been submitted successfully, we will soon reach out to you.
        </p>
        
      </div>
    </div>
  );
  
  
};

export default SubmitPopup;
